module.exports = {
    Optional: require('./source/optional'),
    Result: require('./source/result')
};
